<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header-v2'
import Layout from '@/router/layouts/main'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Setting',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      phaseOneShow: false,
    }
  },

  computed: {
    title() {
      return this.$t('setting.list.maintenance.title')
    },
    subTitle() {
      return this.$t('setting.list.maintenance.description')
    },
    breadcrumbItems() {
      return [
        {
          text: this.$t('setting.homePage.pengaturan'),
          to: '/setting',
        },
        {
          text: this.$t('setting.list.maintenance.title'),
        },
      ]
    },
  },

  methods: {
    redirectToParts() {
      this.$router.push({ name: 'Setting Service Parts' })
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader
      :title="title"
      :subTitle="subTitle"
      :items="breadcrumbItems"
      hasBreadcrumb
      hasBackButton
    />

    <div class="card mc-card mc-card-front">
      <div class="card-body">
        <b-tabs content-class="p-3 text-muted">
          <b-tab active class="border-0">
            <template #title>
              <span class="d-none d-sm-inline-block">
                {{ $t('setting.list.maintenance.title') }}
              </span>
            </template>
            <b-row class="mc-card__list">
              <b-col sm="12" md="6">
                <b-button
                  variant="outline-light"
                  class="d-block w-100 mc-card__list-item clearfix"
                  @click="$router.push({ name: 'Setting Service Activity' })"
                >
                  <i class="mc-fa icon-outline_truck-maintenance"></i>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('setting.list.maintenance.maintenanceActivity') }}</h4>
                    <p>{{ $t('setting.list.maintenance.descriptionMaintenance') }}</p>
                  </div>
                </b-button>
              </b-col>

              <b-col sm="12" md="6">
                <b-button
                  id="button-redirect-parts"
                  v-b-tooltip.hover.center="{
                    title: $t('global.text.underDevelopment'),
                    customClass: 'd-none',
                  }"
                  variant="outline-light"
                  class="d-block w-100 mc-card__list-item clearfix"
                  :class="{
                    'mc-card__list-item--disabled': false,
                  }"
                  @click="redirectToParts"
                >
                  <i class="mc-fa icon-outline_settings"></i>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('setting.list.maintenance.partAndService') }}</h4>
                    <p>{{ $t('setting.list.maintenance.descriptionParts') }}</p>
                  </div>
                </b-button>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </Layout>
</template>
